import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-provider';
var genProStyle = function genProStyle(token) {
  var _$concat$concat, _icon, _small, _token$componentCls;
  return _defineProperty({}, token.componentCls, (_token$componentCls = {
    display: 'inline-flex',
    gap: token.marginXXS,
    alignItems: 'center',
    height: '30px',
    paddingBlock: 0,
    paddingInline: 8,
    fontSize: token.fontSize,
    lineHeight: '30px',
    borderRadius: '2px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: token.colorBgTextHover
    },
    '&-active': _defineProperty({
      paddingBlock: 0,
      paddingInline: 8,
      backgroundColor: token.colorBgTextHover
    }, "&".concat(token.componentCls, "-allow-clear:hover:not(").concat(token.componentCls, "-disabled)"), (_$concat$concat = {}, _defineProperty(_$concat$concat, "".concat(token.componentCls, "-arrow"), {
      display: 'none'
    }), _defineProperty(_$concat$concat, "".concat(token.componentCls, "-close"), {
      display: 'inline-flex'
    }), _$concat$concat))
  }, _defineProperty(_token$componentCls, "".concat(token.antCls, "-select"), _defineProperty({}, "".concat(token.antCls, "-select-clear"), {
    borderRadius: '50%'
  })), _defineProperty(_token$componentCls, "".concat(token.antCls, "-picker"), _defineProperty({}, "".concat(token.antCls, "-picker-clear"), {
    borderRadius: '50%'
  })), _defineProperty(_token$componentCls, '&-icon', (_icon = {
    color: token.colorIcon,
    transition: 'color 0.3s',
    fontSize: 12,
    verticalAlign: 'middle'
  }, _defineProperty(_icon, "&".concat(token.componentCls, "-close"), {
    display: 'none',
    fontSize: 12,
    alignItems: 'center',
    justifyContent: 'center',
    color: token.colorTextPlaceholder,
    borderRadius: '50%'
  }), _defineProperty(_icon, ':hover', {
    color: token.colorIconHover
  }), _icon)), _defineProperty(_token$componentCls, '&-disabled', _defineProperty({
    color: token.colorTextPlaceholder,
    cursor: 'not-allowed'
  }, "".concat(token.componentCls, "-icon"), {
    color: token.colorTextPlaceholder
  })), _defineProperty(_token$componentCls, '&-small', (_small = {
    height: '24px',
    paddingBlock: 0,
    paddingInline: 4,
    fontSize: token.fontSizeSM,
    lineHeight: '24px'
  }, _defineProperty(_small, "&".concat(token.componentCls, "-active"), {
    paddingBlock: 0,
    paddingInline: 8
  }), _defineProperty(_small, "".concat(token.componentCls, "-icon"), {
    paddingBlock: 0,
    paddingInline: 0
  }), _defineProperty(_small, "".concat(token.componentCls, "-close"), {
    marginBlockStart: '-2px',
    paddingBlock: 4,
    paddingInline: 4,
    fontSize: '6px'
  }), _small)), _defineProperty(_token$componentCls, '&-bordered', {
    height: '32px',
    paddingBlock: 0,
    paddingInline: 8,
    border: "".concat(token.lineWidth, "px solid ").concat(token.colorBorder),
    borderRadius: '@border-radius-base'
  }), _defineProperty(_token$componentCls, '&-bordered&-small', {
    height: '24px',
    paddingBlock: 0,
    paddingInline: 8
  }), _defineProperty(_token$componentCls, '&-bordered&-active', {
    backgroundColor: token.colorBgContainer
  }), _token$componentCls));
};
export function useStyle(prefixCls) {
  return useAntdStyle('FieldLabel', function (token) {
    var proToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    });
    return [genProStyle(proToken)];
  });
}